import { render, staticRenderFns } from "./StoryDetail.vue?vue&type=template&id=f9b359e6&scoped=true&"
import script from "./StoryDetail.vue?vue&type=script&lang=js&"
export * from "./StoryDetail.vue?vue&type=script&lang=js&"
import style0 from "./StoryDetail.vue?vue&type=style&index=0&id=f9b359e6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9b359e6",
  null
  
)

export default component.exports